import { render, staticRenderFns } from "./PlaceAnOrder.vue?vue&type=template&id=73755eda&scoped=true&"
import script from "./PlaceAnOrder.vue?vue&type=script&lang=js&"
export * from "./PlaceAnOrder.vue?vue&type=script&lang=js&"
import style0 from "./PlaceAnOrder.vue?vue&type=style&index=0&id=73755eda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73755eda",
  null
  
)

export default component.exports